import { Component, inject, input } from '@angular/core';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { NodePreover } from '@app/models/entity.model';
import { MediaComponent } from '@app/components/media/media.component';
import { RecommendationsComponent } from '@app/components/recommendations/recommendations.component';
import { TeaserListComponent } from '@app/components/teaser-list/teaser-list.component';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { ContentSectionComponent } from '@app/components/content-section/content-section.component';
import { BreakpointService } from '@app/services/breakpoint.service';
import { TeaserComponent } from '@app/components/teaser/teaser.component';
import { HeroTextComponent } from '@app/components/hero-text/hero-text.component';
import { TextComponent } from '@app/components/text/text.component';
import { TeaserStyles } from '@app/models/global.model';
import { CalcUrlPipe } from '@app/pipes/calc-url.pipe';

@Component({
  selector: 'mobi-node-prover',
  templateUrl: './node-prover.component.html',
  styleUrls: ['./node-prover.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    MediaComponent,
    TeaserComponent,
    RecommendationsComponent,
    TeaserListComponent,
    BreadcrumbComponent,
    ContentSectionComponent,
    HeroTextComponent,
    TextComponent,
    BreadcrumbComponent,
    CalcUrlPipe,
  ],
})
/**
 * Node Product Overview Component
 */
export class NodeProverComponent {
  readonly entity = input.required<NodePreover>();
  teaserStyle: TeaserStyles = 'small-illustration';
  breakpoint = inject(BreakpointService);

  hasTeasers(teasers: any) {
    return teasers?.length > 0;
  }
}
